import { Input } from "../ui/input";
import { Field } from "../Field";

export const TextField = ({ id, label, value, onChange, error, hint, type = "text", className = "", inputProps = {} }) => (
  <Field id={id} label={label} error={error} hint={hint} className={className}>
    <Input id={id} type={type} value={value} onChange={(e) => onChange(e.target.value)}
      className={`field-input ${error ? "border-red-500" : ""}`} data-testid={`reg-input-${id.replace(/[._]/g, "-")}`} {...inputProps} />
  </Field>
);

export const StepCustomer = ({ form, set, errors }) => {
  const c = form.customer;
  return (
    <div className="grid sm:grid-cols-2 gap-5" data-testid="reg-step-customer">
      <TextField id="customer.full_name" label="Full name *" value={c.full_name} onChange={set("customer", "full_name")} error={errors["customer.full_name"]} className="sm:col-span-2" />
      <TextField id="customer.email" label="Email *" type="email" value={c.email} onChange={set("customer", "email")} error={errors["customer.email"]} />
      <TextField id="customer.phone" label="Phone *" type="tel" value={c.phone} onChange={set("customer", "phone")} error={errors["customer.phone"]} />
      <TextField id="customer.company" label="Company (optional)" value={c.company} onChange={set("customer", "company")} className="sm:col-span-2" />
    </div>
  );
};
